module.exports = __webpack_public_path__ + "img/full2-min.86c5a300.png";